<template>
  <header class="header">
    <div class="wrapper cf">
      <div class="header__name" v-if="pathPage === '/'">
        Кандинский Николай
        <span class="header__text">персональный сайт</span>
      </div>
      <router-link to="/" title="Персональный сайт Кандинского Николая" class="header__name" v-else>
        Кандинский Николай
        <span class="header__text">персональный сайт</span>
      </router-link>
    </div>
    <HeaderMenu></HeaderMenu>
  </header>
</template>

<script>
  import HeaderMenu from './HeaderMenu.vue'

  export default {
    name: "Header",
    components: {
      HeaderMenu
    },
    data () {
      return {
        mainPage: false,
        pathPage: ''
      }
    },
    watch: {
      '$route' (newValue) {
        this.pathPage = newValue.path
      }
    }
  }
</script>

<style lang="scss" scoped>
.header {
  position: relative;
  text-align: center;

  @media screen and (min-width: 768px){
    text-align: left;
  }

  &__name {
    display: inline-block;
    padding: 10px 0;
    text-align: center;
    font-family: 'EnglishRose-Regular', sans-serif;
    @include font(30px, 38px, #082e76);
    text-decoration: none;

    @media screen and (min-width: 768px){
      display: block;
      padding: 20px 0;
      float: left;
      @include font(40px, 1, #082e76);
    }

    @media screen and (min-width: 1024px){
      @include font(50px, 1, #082e76);
    }
  }

  &__text {
    display: block;
    margin: 3px 0 0;
    text-align: center;
    font-family: Roboto-Regular, sans-serif;
    @include font(14px, 1, #082e76);

    @media screen and (min-width: 768px){
      @include font(18px, 1, #082e76);
    }

    @media screen and (min-width: 1024px){
      @include font(20px, 1, #082e76);
    }
  }
}
</style>